import { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { 
  FaShieldAlt, 
  FaCheckCircle, 
  FaSpinner, 
  FaLightbulb,
  FaBuilding,
  FaUserCheck,
  FaMapMarkerAlt,
  FaSearch
} from 'react-icons/fa';
import { MdVerified, MdLocationOn } from 'react-icons/md';
import { BiSolidShield } from 'react-icons/bi';
import '../../styles/Validando.css';

export default function ValidandoScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const { apiService } = useAuth();
  
  // Pegar parâmetros da URL
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get('id');
  
  const [pulse, setPulse] = useState(false);
  const [status, setStatus] = useState('Validando informações...');
  const [solicitacao, setSolicitacao] = useState(null);
  const [progresso, setProgresso] = useState(0);
  const animationRef = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setPulse(prev => !prev);
    }, 800);
    
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const progressInterval = setInterval(() => {
      setProgresso(prev => {
        if (prev < 90) {
          return prev + 10;
        }
        return prev;
      });
    }, 300);
    
    return () => clearInterval(progressInterval);
  }, []);

  // Buscar detalhes da solicitação
  useEffect(() => {
    async function validarESeguir() {
      if (!id) {
        setStatus('Erro: ID da solicitação não informado');
        setTimeout(() => navigate(-1), 2000);
        return;
      }

      try {
        setStatus('Buscando detalhes da solicitação...');
        console.log('Validando - Buscando detalhes da solicitação ID:', id);
        
        const response = await apiService.getSolicitacaoDetalhe(Number(id));
        console.log('Validando - Resposta:', response);

        if (response.sucesso && response.solicitacao) {
          setSolicitacao(response.solicitacao);
          setStatus('Solicitação validada! Redirecionando...');
          setProgresso(100);
          
          setTimeout(() => {
            navigate(`/registrarAbastecimento?solicitacaoId=${response.solicitacao.id}&dados=${encodeURIComponent(JSON.stringify(response.solicitacao))}`);
          }, 1000);
        } else {
          setStatus(`Erro: ${response.mensagem || 'Solicitação não encontrada'}`);
          setTimeout(() => navigate(-1), 2000);
        }
      } catch (error) {
        console.error('Erro ao buscar solicitação:', error);
        setStatus('Erro ao validar solicitação');
        setTimeout(() => navigate(-1), 2000);
      }
    }

    const timer = setTimeout(validarESeguir, 1500);
    return () => clearTimeout(timer);
  }, [id, navigate, apiService]);

  // Lista de etapas da validação
  const etapas = [
    { id: 1, label: 'Verificando credenciamento do posto', icon: <FaBuilding /> },
    { id: 2, label: 'Validando ativação do frentista', icon: <FaUserCheck /> },
    { id: 3, label: 'Confirmando localização', icon: <FaMapMarkerAlt /> },
    { id: 4, label: 'Buscando detalhes da solicitação', icon: <FaSearch /> },
  ];

  const etapaAtiva = Math.min(Math.floor(progresso / 25), 3);
  const etapasConcluidas = etapas.map((_, index) => index <= etapaAtiva);

  return (
    <div className="validando-web">
      <div className="validando-card">
        <div className={`icon-wrapper ${pulse ? 'pulse' : ''}`}>
          <div className="icon-circle">
            <BiSolidShield className="shield-icon" />
          </div>
          <div className="icon-ring"></div>
        </div>

        {/* Barra de progresso */}
        <div className="progress-wrapper">
          <div className="progress-bar-container">
            <div className="progress-bar-fill" style={{ width: `${progresso}%` }}>
              <div className="progress-glow"></div>
            </div>
          </div>
          <div className="progress-percentage">{progresso}%</div>
        </div>

        <h2 className="status-title">{status}</h2>
        <p className="status-description">
          Verificando credenciamento do posto, ativação do frentista e localização...
        </p>

        {/* Lista de etapas */}
        <div className="etapas-container">
          {etapas.map((etapa, index) => (
            <div 
              key={etapa.id} 
              className={`etapa-web ${etapasConcluidas[index] ? 'completed' : ''} ${etapaAtiva === index ? 'active' : ''}`}
            >
              <div className="etapa-icon">
                {etapasConcluidas[index] ? (
                  <FaCheckCircle className="icon-success" />
                ) : etapaAtiva === index ? (
                  <FaSpinner className="icon-loading spin" />
                ) : (
                  etapa.icon
                )}
              </div>
              <div className="etapa-content">
                <span className="etapa-label">{etapa.label}</span>
                {etapasConcluidas[index] && (
                  <span className="etapa-status">Concluído</span>
                )}
                {etapaAtiva === index && !etapasConcluidas[index] && (
                  <span className="etapa-status in-progress">Em andamento</span>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="dica-web">
          <FaLightbulb className="dica-icon" />
          <div className="dica-content">
            <h4>Processo automático</h4>
            <p>Este processo é automático e leva apenas alguns segundos. Aguarde enquanto validamos as informações.</p>
          </div>
        </div>
      </div>
    </div>
  );
}